import en from './lang/en/en';
import de from './lang/de/de';
import fr from './lang/fr/fr';
import gggen from './lang/en/gggen';
import gggde from './lang/de/gggde';
import gggfr from './lang/fr/gggfr';
import { appNames } from './lib/appNames';
import { App } from './lib/app';
import gggnl from './lang/nl/gggnl';
const currentApp = process.env.CURRENT_APP || App.getAppName();
let selectedEnglish = en;
let selectedFrench = fr;
let selectedGerman = de;
let selectedDutch = gggnl;
if (currentApp) {
  if (currentApp == appNames.getGreenGold) {
    selectedEnglish = gggen;
    selectedFrench = gggfr;
    selectedGerman = gggde;
    selectedDutch = gggnl
  }
  if (currentApp == appNames.inaiaEu) {
    selectedEnglish = en;
    selectedFrench = fr;
    selectedGerman = de;
  }
}
const customDateFormats = {
  DATETIME: { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false },
  DATE: { year: 'numeric', month: '2-digit', day: '2-digit' },
  TIME: { hour: '2-digit', minute: '2-digit', hour12: false },
} as const;
const numberFormating = {
  'en-US': {
    // Define a custom format named 'twoDigits' for en-US
    twoDigits: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    // You can also define other formats like currency
    
  },
  'fr-FR': {
    // Define a custom format named 'twoDigits' for fr-FR
    twoDigits: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    
  },
  // Add more locales as needed
};

export default defineI18nConfig(() => ({
    fallbackLocale: 'en',
    legacy: false,
    locale: 'en',
    messages: {
      de: selectedGerman,
      en: selectedEnglish,
      fr: selectedFrench,
      nl: selectedDutch
    },
    numberFormats:{
      'en':{
        'twoDigits':{
          style:'decimal',
          minimumFractionDigits:2,
          maximumFractionDigits:2
        }
      },
      'de':{
        'twoDigits':{
          style:'decimal',
          minimumFractionDigits:2,
          maximumFractionDigits:2
        }
      },
      'fr':{
        'twoDigits':{
          style:'decimal',
          minimumFractionDigits:2,
          maximumFractionDigits:2
        }
      },
      'nl':{
        'twoDigits':{
          style:'decimal',
          minimumFractionDigits:2,
          maximumFractionDigits:2
        }
      }
    },
    datetimeFormats: {
      en: customDateFormats,
      de: customDateFormats,
      fr: customDateFormats,
      nl: customDateFormats
    }

  }))